import * as React from "react";
import { IItem } from "../../models/IItem";
import TLEntryMailRequest from "./TLEntryMailRequest";
import TLEntryDesignationQueue from "./TLEntryDesignationQueue";
import TLEntryAccessHistory from "./TLEntryAccessHistory";
import TLEntryAssignmentHistory from "./TLEntryAssignmentHistory";
import TLEntryEventQueue from "./TLEntryEventQueue";
import TLEntryDatumHistory from "./TLEntryDatumHistory";
import TLEntryOtherHistory from "./TLEntryOtherHistory";
import { DataAccess } from "../../data/DataAccess";
import { useEffect, useState } from "react";
import { TogglesClass } from "./Toggles";

interface WorkflowTimelineProps {
  FIGUID: string;
  EventTable: IItem[];
  DesignationTable: IItem[];
  CommitTable: IItem[];
  AccessTable: IItem[];
  CommitDatumsTable: IItem[];
  AssignmentHistoryTable: IItem[];
  OtherTable: IItem[];
  MailTable: IItem[];
  DA: DataAccess;
  Toggles: TogglesClass;
  TechView: boolean;
  PassthroughRequeue: (EID: Number, FIGUID: string) => void;
}

class Interleaf {
  ID: number;
  Type: string;
  Object: any;
  Data: any[];
  Condensed: boolean;

  constructor() {
    this.ID = 0;
    this.Type = "";
    this.Object = {};
    this.Data = [];
    this.Condensed = true;
  }
}

export default function Timeline(props: WorkflowTimelineProps) {
  const [Interleaved, SetInterleaved] = useState<Array<Interleaf>>([]);

  const ToggleCondensed = (ident: number) => {
    var _inters = [...Interleaved];
    var _i = _inters.findIndex((th) => th.ID === ident);
    _inters[_i].Condensed = !_inters[_i].Condensed;
    SetInterleaved(_inters);
  };

  // assemble interleaved entries
  useEffect(() => {
    var proto_Interleaved: Interleaf[] = [];
    // populate Interleaved with Date, Type, Contents for all other tables.
    var i: number = 0;

    props.EventTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryEventQueue";
      proto_Interleaved[i].Object = th;
      i++;
    });

    props.DesignationTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryDesignationQueue";
      proto_Interleaved[i].Object = th;
      i++;
    });

    props.AccessTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryAccessHistory";
      proto_Interleaved[i].Object = th;
      i++;
    });

    props.AssignmentHistoryTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryAssignmentHistory";
      proto_Interleaved[i].Object = th;
      i++;
    });

    props.OtherTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryOtherHistory";
      proto_Interleaved[i].Object = th;
      i++;
    });
    props.CommitTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryDatumHistory";
      proto_Interleaved[i].Object = th;
      proto_Interleaved[i].Data = props.CommitDatumsTable.filter(
        (ith: { CommitID: any }) => ith.CommitID === th.CommitID,
      );
      i++;
    });

    props.MailTable.forEach((th: any) => {
      proto_Interleaved[i] = new Interleaf();
      proto_Interleaved[i].Type = "TLEntryMailRequest";
      proto_Interleaved[i].Object = th;
      i++;
    });

    var j: number = 0;

    proto_Interleaved
      .sort((a: Interleaf, b: Interleaf) => {
        return a.Object["Timestamp"] > b.Object["Timestamp"] ? 1 : -1;
      })
      .forEach((th) => {
        th.ID = j;
        j = j + 1;
      });

    //  if (proto_Interleaved !== undefined) {
    //    if (proto_Interleaved.length > 0) {
    //      var ts = proto_Interleaved[0].Object["Timestamp"]
    //      console.log(ts);
    //      console.log(ts as Date);
    //    }
    //  }

    if (
      props.Toggles !== undefined &&
      props.Toggles.SortTimeDescending === true
    ) {
      proto_Interleaved = proto_Interleaved.sort(
        (a: Interleaf, b: Interleaf) => {
          return (a.Object["Timestamp"] as Date) >
            (b.Object["Timestamp"] as Date)
            ? -1
            : 1;
        },
      );
    } else {
      proto_Interleaved = proto_Interleaved.sort(
        (a: Interleaf, b: Interleaf) => {
          return (a.Object["Timestamp"] as Date) >
            (b.Object["Timestamp"] as Date)
            ? 1
            : -1;
        },
      );
    }

    SetInterleaved(proto_Interleaved);
  }, [
    props.EventTable,
    props.DesignationTable,
    props.CommitTable,
    props.CommitDatumsTable,
    props.AssignmentHistoryTable,
    props.OtherTable,
    props.Toggles,
  ]);

  return (
    <div className="Timeline">
      {Interleaved.map((row: Interleaf, i: number) => {
        if (
          row.Type === "TLEntryDesignationQueue" &&
          props.Toggles.ShowDesignations
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryDesignationQueue
                Object={row.Object}
                Toggles={props.Toggles}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryEventQueue" &&
          props.Toggles.ShowEvents
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryEventQueue
                FIGUID={props.FIGUID}
                DA={props.DA}
                Object={row.Object}
                Toggles={props.Toggles}
                TechView={props.TechView}
                PassthroughRequeue={props.PassthroughRequeue}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryAssignmentHistory" &&
          props.Toggles.ShowAssignments
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryAssignmentHistory
                Object={row.Object}
                Toggles={props.Toggles}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryAccessHistory" &&
          props.Toggles.ShowAccessLocks
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryAccessHistory
                Object={row.Object}
                Toggles={props.Toggles}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryDatumHistory" &&
          props.Toggles.ShowData
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryDatumHistory
                Object={row.Object}
                Toggles={props.Toggles}
                Data={row.Data}
                Squished={row.Condensed}
                ID={row.ID}
                SquishMe={ToggleCondensed}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryOtherHistory" &&
          props.Toggles.ShowOther
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryOtherHistory
                Object={row.Object}
                Toggles={props.Toggles}
              />
            </React.Fragment>
          );
        } else if (
          row.Type === "TLEntryMailRequest" &&
          props.Toggles.ShowMail
        ) {
          return (
            <React.Fragment key={row.ID}>
              <TLEntryMailRequest
                Object={row.Object}
                Toggles={props.Toggles}
                Squished={row.Condensed}
                ID={row.ID}
                SquishMe={ToggleCondensed}
              />
            </React.Fragment>
          );
        } else {
          return <React.Fragment key={row.ID}></React.Fragment>;
        }
      })}
    </div>
  );
}
